<template>
  <div class="py-3">
    <img :src="NoDataImg" alt="no-data" class="img-fluid mx-auto d-block" />
    <div class="text-center pt-3">
      <h4>Sin coincidencias</h4>
      <small class="text-secondary">
        Parece que la consulta realizada no arrojó ningún resultado. <br />
      </small>
    </div>
  </div>
</template>

<script>
import NoDataImg from "@/assets/img/illustrations/no-data.png";

export default {
  data() {
    return {
      NoDataImg,
    };
  },
};
</script>

<style scoped>
img {
  max-width: 20em;
}
</style>
